<template>
  <div
    id="app"
    :class="from === 'iframe' ? '' : !isMainApp ? 'marginLeft50' : ''"
  >
    <layout></layout>
  </div>
</template>
<style>
.el-input__inner {
  border-radius: 1px;
}
</style>
<script>
import layout from './components/layout/LayoutMicroFront'
export default {
  name: 'App',
  components: {
    layout: layout
  },
  data () {
    return {
      isMainApp: false,
      from: ''
    }
  },
  mounted () {
    this.from = this.getQueryString('from')
    this.isMainApp = document.querySelector('#mainApp')
    document.addEventListener('visibilitychange', this.visibleChange)
    // Array.prototype.removeByValue = function (val) {
    //   for (var i = 0; i < this.length; i++) {
    //     if (this[i] == val) {
    //       this.splice(i, 1)
    //       break
    //     }
    //   }
    // }
    // Array.prototype.removeNullArray = function (arr) {
    //   arr = arr.filter(e => {
    //     return e && e != []
    //   })
    //   return arr
    // }
    // Date.prototype.simpleDateFormate = function (format, date = new Date()) {
    //   var o = {
    //     'M+': this.getMonth() + 1, // month
    //     'd+': this.getDate(), // day
    //     'h+': this.getHours(), // hour
    //     'm+': this.getMinutes(), // minute
    //     's+': this.getSeconds(), // second
    //     'q+': Math.floor((this.getMonth() + 3) / 3), // quarter
    //     'S': this.getMilliseconds() // millisecond
    //   }
    //   if (/(y+)/.test(format)) {
    //     console.log(RegExp.$1.length)
    //     format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    //   }
    //   for (var k in o) {
    //     if (new RegExp('(' + k + ')').test(format)) {
    //       format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    //     }
    //   }
    //   return format
    // }
  },
  destroyed () {
    document.removeEventListener('visibilitychange', this.visibleChange)
  },
  methods: {
    visibleChange () {
      if (document.visibilityState === 'visible') {
        this.$store.commit('SET_PAGEVISIBLE', true)
      } else {
        this.$store.commit('SET_PAGEVISIBLE', false)
      }
    },
    getQueryString (e) {
      var t = new RegExp('(^|&)' + e + '=([^&]*)(&|$)')
      var search = location.href
      var a = search.substr(1).match(t)
      if (a != null) return a[2]
      return ''
    }
  }
}
</script>
<style lang="scss">
.marginLeft50 {
  margin-left: 50px;
}
</style>
